import { Component } from 'vue-property-decorator';
import { Button, PaneDropdown } from 'streamlabs-beaker';
import Base from '@/components/Base';
import RTMPInfoModal from '@/components/topnav/modals/RTMPInfoModal.vue';
import { EPlatformNames } from '@/helpers/platforms';

@Component({
  components: {
    SButton: Button,
    SPaneDropdown: PaneDropdown,
    RTMPInfoModal,
  },
})
export default class AvatarDropdown extends Base {
  get avatar(): string {
    return this.currentUser?.avatar_url || 'https://cdn.streamlabsstudio.com/static/imgs/icons/user-icon-round-min.png';
  }

  get connectedPlatforms() {
    return [
      this.userTwitchAccount && {
        name: EPlatformNames.twitch,
        iconClass: 'icon-twitch',
        username: this.userTwitchAccount.name,
        link: this.userTwitchAccount.link,
      },
      this.userYouTubeAccount && {
        name: EPlatformNames.youtube,
        iconClass: 'icon-youtube',
        username: this.userYouTubeAccount.name,
        link: this.userYouTubeAccount.link,
      },
      this.userTiktokAccount && {
        name: EPlatformNames.tiktok,
        iconClass: 'icon-tiktok',
        username: this.userTiktokAccount.name,
        link: this.userTiktokAccount.link,
      },
      this.userKickAccount && {
        name: EPlatformNames.kick,
        iconClass: 'icon-kick',
        username: this.userKickAccount.name,
        link: this.userKickAccount.link,
      }
    ].filter(Boolean);
  }

  openLink(link: string) {
    window.open(link, '_blank');
  }

  // openRTMPInfoModal() {
  //   this.$modal.show(EModalName.RTMPInfoModal);
  // }
}
